import React, { PropTypes } from 'react';

import './CompactList.scss';

export default function CompactList({ children }) {
  return (
    <div className="cp-compact-list">
      {children}
    </div>
  );
}

CompactList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};



// WEBPACK FOOTER //
// ./app/components/shared/CompactList/CompactList.jsx